<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="priceLevelName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="status">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-open-link-column [linkPath]="'price-level'" [parameterResolver]="getPriceLevelEditParams" field="priceLevelName"></wbo-open-link-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
